import Hero from "./components/Hero";
import {
  OngoingProjectSection,
  PartnerSection,
  FaqSection,
  FeatureSection,
  TestimonialSection,
} from "components";
import { lenderFeature } from "./constant";

const Lenders = () => {
  return (
    <>
      <Hero />
      <PartnerSection />
      <FeatureSection features={lenderFeature} />
      <OngoingProjectSection />
      <TestimonialSection />
      <FaqSection />
    </>
  );
};

export default Lenders;
